<template>
  <div class="introduce article">
    <div class="topbar" v-if="title == '基金会介绍'">
      <img width="100%" src="/static/project/topbar.png" />
    </div>
    <div class="topbar" v-if="title == '项目介绍'">
      <img width="100%" src="/static/project/topbar-project.png" />
    </div>
    <div class="topbar" v-if="title == '常见问题'">
      <img width="100%" src="/static/project/topbar-problem.png" />
    </div>
    <div class="article-c" v-html="text"></div>
    <div class="article-btn btn">
      <van-button type="info" block round @click="goback" color="#0AA8AF"
        >返回</van-button
      >
    </div>
  </div>
</template>

<script>
var jweixin = require("jweixin-module");
import { articles } from "../../api/api";
export default {
  data() {
    return {
      title: "",
      text: "",
    };
  },
  mounted() {
    this.gettext();
    // console.log(this.$route.query.column_id)
  },
  methods: {
    async gettext() {
      await articles({
        params: {
          "ArticleSearch[column_id]": this.$route.query.column_id,
          sort: "sortnum desc",
          "ArticleSearch[id]": this.$route.query.id,
        },
      }).then((res) => {
        this.title = res.data.items[0].title;
        this.text = res.data.items[0].content;
      });
    },
    goback() {
      this.$router.replace({
        name: "Introduce",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.introduce {
  padding-top: 0;
  padding-bottom: 70px;
  .topbar {
  }
  .article-c {
    // line-height:180%;
    text-align-last: auto;
  }
  // height: 100%;
  // width: 100%;

  // box-sizing: border-box;
  // .text{
  // padding: 10px;
  // img,video,iframe {
  // max-width: 100% !important; height: auto;
  // }
  // }
  // .btn{
  // position: fixed;
  // bottom: 0;
  // left: 0;
  // background: #F7F8FF ;
  // z-index: 99;
  // padding-bottom: 20px;
  // box-sizing: border-box;
  // }
}
</style>